import { memo } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";

import type { UseCrmWhatsAppAccountConfigFormResult } from "../hooks/useCrmWhatsAppAccountConfigForm";

export interface CrmWhatsAppAccountConfigFormProps {
  form: UseCrmWhatsAppAccountConfigFormResult;
}

const CrmWhatsAppAccountConfigForm = memo(
  ({ form }: CrmWhatsAppAccountConfigFormProps) => {
    return (
      <Box
        component="form"
        onSubmit={form.handleSubmit}
        sx={{ mt: 0.5, display: "flex", flexDirection: "column", gap: 2 }}
      >
        <Stack spacing={2}>
          <TextField
            label="Número WABA (WhatsApp Business API)"
            placeholder="+55 11 99999-0000"
            fullWidth
            disabled={form.isSubmitting}
            error={Boolean(form.formErrors.wabaPhoneNumber)}
            helperText={form.formErrors.wabaPhoneNumber?.message}
            {...form.register("wabaPhoneNumber", {
              required: "Campo obrigatório",
            })}
          />

          <TextField
            label="Número de WhatsApp configurado"
            placeholder="+55 11 98888-7777"
            fullWidth
            disabled={form.isSubmitting}
            error={Boolean(form.formErrors.whatsappPhoneNumber)}
            helperText={form.formErrors.whatsappPhoneNumber?.message}
            {...form.register("whatsappPhoneNumber", {
              required: "Campo obrigatório",
            })}
          />

          <TextField
            label="ID do gerenciador de templates (Meta)"
            placeholder="act_123456789012345"
            fullWidth
            disabled={form.isSubmitting}
            error={Boolean(form.formErrors.metaBusinessAccountId)}
            helperText={form.formErrors.metaBusinessAccountId?.message}
            {...form.register("metaBusinessAccountId", {
              required: "Campo obrigatório",
            })}
          />

          <TextField
            label="Status da conexão"
            placeholder="Conectado"
            fullWidth
            disabled={form.isSubmitting}
            error={Boolean(form.formErrors.connectionStatusLabel)}
            helperText={form.formErrors.connectionStatusLabel?.message}
            {...form.register("connectionStatusLabel", {
              required: "Campo obrigatório",
            })}
          />
        </Stack>
      </Box>
    );
  },
);

CrmWhatsAppAccountConfigForm.displayName =
  "CrmWhatsAppAccountConfigForm";

export default CrmWhatsAppAccountConfigForm;

